import React, { FunctionComponent } from "react";
import { ICardElementWithChildren } from "backend/model/model";
import TextElement from "reportengine/TextElement";
import Text from "reportengine/Text";
import Report from "reportengine/Report";
import Slide from "reportengine/Slide";
import { createReport, saveBlob } from "reportengine/createReport";
import reportContextToRequest from "./reportContextToRequest";
import DomElement from "reportengine/DomElement";
import SlowRenderingComponent from "reportengine/testcomponents/SlowRenderingComponent";
import ProgressModal from "design/components/progress/ProgressModal";
import Portion from "reportengine/Portion";
import PerformanceTrendView from "design/components/charts/PerformanceTrendView";
import { Series } from "design/components/charts/types";
import { formatDate, getDateFromMEAValue } from "utils/utils";
import PerformanceTrend from "components/PerformanceTrend";
import InitiativeProgressCard from "design/components/cards/InitiativeProgressCard/InitiativeProgressCard";
import ProgressBar from "design/components/progress/ProgressBar";
import { PerformanceDonut } from "design/components/charts/PerformanceDonut";
import useYearsLastPeriod from "backend/hooks/model/useYearsLastPeriod";
import KPISlide from "./slides/KPISlide";

const KPIReport = (
  props: React.PropsWithChildren<{
    item: ICardElementWithChildren;
    filetype: string;
    onClose?: () => void;
  }>
) => {
  const { item, filetype } = props;
  const lastPeriod = useYearsLastPeriod(item.period?.name || "");
  const [progress, setProgres] = React.useState(0);
  const [blob, setBlob] = React.useState<null | Blob>(null);
  const [status, setStatus] = React.useState<string>("Generating report");

  console.log("KPIReport item ", props.item);

  return (
    <div>
      <ProgressModal
        isOpen
        onClose={() => {
          if (props.onClose) {
            props.onClose();
          }
        }}
        isComplete={!!blob}
        cancelClickHandler={props.onClose}
        completedClickHandler={() => {
          if (blob) {
            saveBlob(`${item.symbol}.${filetype}`, blob);
          }
        }}
        downloadText="Download"
        progress={progress}
        statusText={status}
      />
      <Report
        isReady={!!lastPeriod}
        template="/templates/report_en.pptx"
        onNothingToRender={() => {}}
        onProgress={(value) => {
          setProgres(value);
        }}
        onReadyToRender={async (report) => {
          setStatus("Exporting slides");
          setProgres(95);
          const blob = await createReport(
            await reportContextToRequest(report, item.symbol, filetype)
          );
          setProgres(100);
          setStatus("Report ready");
          setBlob(blob);
        }}
      >
        <Slide index={0}>
          <TextElement slideElement="title">KPI Details</TextElement>
          <TextElement slideElement="subtitle">{item.name}</TextElement>
          <TextElement slideElement="footer">
            {item.period?.name || ""}
          </TextElement>
        </Slide>
        <KPISlide item={item} />
      </Report>
    </div>
  );
};

export default KPIReport;
